<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.reports'), $t('reports.paymentDetail')]">
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="100px"
      >
        <el-form-item
          :label="$t('payment.receiveAt')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.date')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="daterangeValue"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <el-form-item :label="$t('payment.ownerName')">
          <el-checkbox-group v-model="searchForm.ownerIds">
            <el-checkbox v-for="user of users" :key="user.id" :label="user.id">
              <span v-if="user.voidAt != null" class="deleted">
                {{ user.name }}
              </span>
              <span v-else>{{ user.name }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="$t('payment.shop')">
          <el-checkbox-group v-model="searchForm.shopIds">
            <el-checkbox
              v-for="(shop, index) of shops"
              :key="index"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="$t('payment.payMethodReceive')">
          <el-checkbox-group v-model="searchForm.payMethodIds">
            <el-checkbox
              v-for="payMethod of payMethods"
              :key="payMethod.id"
              :label="payMethod.id"
            >
              {{ payMethod.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="$t('payment.type')">
          <el-checkbox-group v-model="searchForm.types">
            <el-checkbox label="normal">
              {{ $t("action.payment") }}
            </el-checkbox>
            <el-checkbox label="return">
              {{ $t("action.paymentReturn") }}
            </el-checkbox>
            <el-checkbox label="ignore">
              {{ $t("action.paymentIgnore") }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br />

        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
            <span v-if="totals.length != 0" class="pager-total">
              <span v-for="(item, itemIdx) of totals" :key="itemIdx">
                合计:
                <currency :code="item.currency"></currency>{{ item.total }},
                收款:<currency :code="item.currency"></currency>{{ item.in }},
                退款:<currency :code="item.currency"></currency>{{ item.out }},
                抹零: <currency :code="item.currency"></currency
                >{{ item.inIgnore }}
                <strong v-if="itemIdx != totals.length - 1"> / </strong>
              </span>
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="total"
          :title="$t('payment.total')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.total }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payMethodName"
          :title="$t('payment.payMethodReceive')"
          min-width="100"
        ></vxe-table-column>
        <vxe-table-column
          field="paidAt"
          :title="$t('payment.paidAt')"
          min-width="110"
        ></vxe-table-column>

        <vxe-table-column
          field="voucher"
          :title="$t('payment.voucher')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <thumbnail-text :srcs="row.voucher" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="explain"
          :title="$t('payment.explain')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.explain" :number="8" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('payment.ownerName')"
          min-width="80"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('payment.shop')"
          min-width="80"
        />
        <vxe-table-column
          field="serialNo"
          :title="$t('notice.serialNo')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <span>
              <el-popover placement="right" width="300" trigger="click">
                <div>
                  <div class="lineH24">
                    {{ $t("menu.customers") }}:
                    {{ row.customerName }}
                  </div>
                  <div class="lineH24">
                    {{ $t("text.createAt") }}:
                    {{ row.bargainCreateAt }}
                  </div>
                  <!-- <div class="lineH24">
                    {{ $t("order.serialNo") }}:
                    {{ row.orderSerialNos }}
                  </div> -->
                </div>
                <span slot="reference" class="popover-reference">
                  {{ row.bargainSerialNo }}
                </span>
              </el-popover>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="itemInfoStr"
          :title="'相关产品'"
          min-width="140"
        >
          <template v-slot="{ row }">
            <span class="font10">{{ row.productInfos }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import ThumbnailText from "@/components/ThumbnailText";
import Currency from "@/components/Currency";
import Util from "@/utils/index.js";

import User from "@/api/user";
import Shop from "@/api/shop";
import PayMethod from "@/api/payMethod";
import BackBargainPayment from "@/api/backBargainPayment";

export default {
  mixins: [page, table.pager, table.search],
  components: { DateRange, ThumbnailText, Currency },
  data() {
    return {
      daterangeValue: null,
      searchForm: {
        paidAtStartAt: null,
        paidAtEndAt: null,
        shopIds: [],
        ownerIds: [],
        payMethodIds: [],
        types: [],
      },
      users: [],
      shops: [],
      payMethods: [],
      //
      records: [],
      totals: [],
      loading: false,
      actionPageDF: false,
    };
  },

  created() {
    const self = this;
    if (self.$route.query && self.$route.query.settleAt !== undefined) {
      self.daterangeValue = [
        new Date(Util.reportStartAt(self.$route.query.settleAt)),
        new Date(Util.reportEndAt(self.$route.query.settleAt)),
      ];
      self.loadData();
    }
    axios
      .all([
        Shop.findByTenantId(),
        User.findByTenantId(),
        PayMethod.findByTypes({ types: PayMethod.saleTypes }),
      ])
      .then(
        axios.spread(function (shops, users, payMethods) {
          if (shops.status == 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
          if (users.status == 200) {
            const allUsers = users.data.filter(
              (u) =>
                (u.voidAt == null && u.authorize == true) || u.voidAt != null
            );
            if (self.Permit.currentUser().admin === true) {
              self.users = allUsers;
            } else {
              self.users = allUsers.filter((u) =>
                JSON.parse(self.Permit.currentUser().manageUsers).includes(u.id)
              );
            }
          } else {
            self.sysError();
          }
          if (payMethods.status === 200) {
            self.payMethods = payMethods.data;
            self.payMethods.push({
              id: -1,
              name: "账户余额",
            });
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    //
    download() {
      const self = this;
      if (self.daterangeValue == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("payment.receiveAt")]),
          type: "warning",
        });
        return;
      }
      self.searchForm.paidAtStartAt = Util.formatDateTime(
        this.daterangeValue[0]
      );
      self.searchForm.paidAtEndAt = Util.formatDateTime(this.daterangeValue[1]);
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      BackBargainPayment.exportExcel(self.combineParams()).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedRows = [];
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    //
    loadData() {
      const self = this;
      if (self.daterangeValue == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("payment.receiveAt")]),
          type: "warning",
        });
        return;
      }
      self.searchForm.paidAtStartAt = Util.formatDateTime(
        this.daterangeValue[0]
      );
      self.searchForm.paidAtEndAt = Util.formatDateTime(this.daterangeValue[1]);
      self.loading = true;
      BackBargainPayment.search(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data.records;
          self.pager.total = res.data.total;
          self.getTotal();
        } else {
          self.sysError();
        }
      });
    },
    getTotal() {
      const self = this;
      if (self.actionPageDF) {
        return;
      }
      BackBargainPayment.searchCount(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.totals = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    changePager(params) {
      this.pager.currentPage = params.currentPage;
      this.pager.pageSize = params.pageSize;
      this.actionPageDF = true;
      this.loadData();
    },
    combineParams() {
      let params = {};
      if (this.pager) {
        params.currentPage = this.pager.currentPage;
        params.pageSize = this.pager.pageSize;
      }
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>